import React from "react";
import { Phone } from "lucide-react";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-6 right-6 z-[60] flex flex-col gap-4" data-testid="floating-actions">
      {/* WhatsApp */}
      <a
        href="https://wa.me/905449751294?text=Merhaba%2C%20YK%20%C4%B0n%C5%9Faat%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp'tan yazın"
        data-testid="floating-whatsapp"
        className="relative w-14 h-14 rounded-full flex items-center justify-center bg-[#25D366] text-white shadow-[0_10px_30px_-10px_rgba(37,211,102,0.7)] hover:scale-110 transition-transform duration-300"
        style={{ animation: "yk-breath-green 2.4s ease-in-out infinite" }}
      >
        <span
          className="absolute inset-0 rounded-full bg-[#25D366]"
          style={{ animation: "yk-ping 2.4s cubic-bezier(0,0,0.2,1) infinite", opacity: 0.4 }}
          aria-hidden="true"
        ></span>
        <svg viewBox="0 0 32 32" className="w-7 h-7 relative z-10" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.44c-.28-.14-1.65-.81-1.9-.91-.26-.09-.44-.14-.63.14-.19.28-.72.91-.88 1.09-.16.19-.32.21-.6.07-.28-.14-1.17-.43-2.23-1.38-.83-.73-1.38-1.64-1.54-1.92-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.63-1.52-.86-2.08-.23-.55-.46-.47-.63-.48H10.1c-.19 0-.49.07-.75.35-.26.28-.98.96-.98 2.34s1.01 2.71 1.15 2.9c.14.19 1.98 3.03 4.81 4.25.67.29 1.19.46 1.6.59.67.21 1.29.18 1.77.11.54-.08 1.65-.67 1.88-1.32.23-.65.23-1.21.16-1.32-.07-.11-.25-.18-.53-.32zM16.03 6.13c-5.47 0-9.9 4.44-9.9 9.9 0 1.75.45 3.46 1.32 4.97L6.03 26l5.13-1.35c1.46.8 3.11 1.22 4.87 1.22 5.47 0 9.9-4.44 9.9-9.9s-4.43-9.84-9.9-9.84zm0 18.13c-1.5 0-2.97-.41-4.24-1.18l-.3-.18-3.05.8.81-2.97-.2-.31c-.85-1.35-1.29-2.9-1.29-4.5 0-4.65 3.79-8.44 8.44-8.44 2.25 0 4.37.88 5.96 2.47 1.59 1.59 2.47 3.71 2.47 5.96-.01 4.66-3.8 8.35-8.6 8.35z" />
        </svg>
      </a>

      {/* Direkt Ara */}
      <a
        href="tel:05449751294"
        aria-label="Direkt ara"
        data-testid="floating-call"
        className="relative w-14 h-14 rounded-full flex items-center justify-center bg-[#EF4444] text-white shadow-[0_10px_30px_-10px_rgba(239,68,68,0.75)] hover:scale-110 transition-transform duration-300"
        style={{ animation: "yk-breath-red 2.4s ease-in-out infinite" }}
      >
        <span
          className="absolute inset-0 rounded-full bg-[#EF4444]"
          style={{ animation: "yk-ping 2.4s cubic-bezier(0,0,0.2,1) infinite 0.6s", opacity: 0.4 }}
          aria-hidden="true"
        ></span>
        <Phone className="w-6 h-6 relative z-10" strokeWidth={2} />
      </a>
    </div>
  );
}
